module.exports = __webpack_public_path__ + "static/background-hero-lg-d1dc391a3a9faede72d8671977c2a70a.png";